import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormSection } from "redux-form";

import  {
	Card,
	ProgressIndicator
} from "rhombus-react";

import { loadFacebookPages } from "reducers/Social";
import { SOCIAL_AD_TYPES } from "utils/constants";
import { FACEBOOK_CAROUSEL_FIELDS } from "social/carousel/FacebookCarouselCardForm";
import { useErrorBanner } from "social/utils";

import FacebookMainContent from "social/carousel/FacebookMainContent";
import FacebookCardContent from "social/carousel/FacebookCardContent";

export default function FacebookCarousel(props){
	const {
		isEditMode,
		libraryId,
		navigationActions,
		isViewOnly,
		showPristineErrors,
	} = props;
	const adType = SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL;

	const showPristine = showPristineErrors || ["cardCount"]; // Always show at least the card count error

	const dispatch = useDispatch();
	const isLoading = useSelector(state => state.social?.facebookPages?.isLoading);

	const errorDisplay = useErrorBanner(adType, showPristine, FACEBOOK_CAROUSEL_FIELDS);

	useEffect(() => {
		dispatch(loadFacebookPages(libraryId));
	}, [libraryId]);

	return (
		<FormSection name={adType}>
			<div className="carousel-modal-content progress-container">
				{errorDisplay}
				<ProgressIndicator isLoading={isLoading} />
				<Card
					className="carousel-main-content"
					header="Main Content"
					isCollapsable
					isVisible
				>
					<FacebookMainContent
						adType={adType}
						isEditMode={isEditMode}
						isViewOnly={isViewOnly}
						showPristineErrors={showPristineErrors}
					/>
				</Card>
				<FacebookCardContent
					libraryId={libraryId}
					adType={adType}
					isViewOnly={isViewOnly}
					showPristineErrors={showPristineErrors}
					navigationActions={navigationActions}
				/>
			</div>
		</FormSection>
	);
}
